import { useCallback, useEffect } from "react"

import { useLocation, useNavigate } from "react-router-dom"
import { RoutePath } from "routes/Route.types"
import {
  mergePostLoginRedirectFromRouterState,
  takeIntendedPathAfterLogin,
} from "utils/postLoginRedirect"

/**
 * Merges the router `state.from` into sessionStorage on mount (fallback for
 * redirect-before-login), and returns a stable callback that reads the
 * intended path, clears it, and navigates there (or to HOMEPAGE as default).
 */
const usePostLoginNavigate = () => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    mergePostLoginRedirectFromRouterState(location.state)
  }, [location.key])

  return useCallback(() => {
    const redirect = takeIntendedPathAfterLogin()
    queueMicrotask(() => navigate(redirect ?? RoutePath.HOMEPAGE, { replace: true }))
  }, [navigate])
}

export default usePostLoginNavigate
